import { LABEL } from '../../veriables';

export default {
    tHead : [
        {
          key: 'checkbox',
          name: LABEL().RECEIPT_SELECT
        },
        {
          key: 'cardType',
          name: LABEL().CARD_TYPE,
        },
        {
          key: 'redactedCardNumber',
          name: LABEL().REDACTED_CARD_NUMBER,
        },
        {
          key: 'cardHolderName',
          name: LABEL().NAME,
        },
        {
          key: 'ticketAmount',
          name: LABEL().TOTAL,
          prefix: `${LABEL().CURRENCY_SYMBOL}`,
        },
        {
          key: 'tipAmount',
          name: LABEL().TIP,
          prefix: `${LABEL().CURRENCY_SYMBOL}`,
        },
        {
          key: 'paymentStatus',
          name: LABEL().PAYMENT,
        },
        {
          key: 'printStatus',
          name: LABEL().RECEIPT_PRINT_STATUS
        }
    ],
    tableHead : [
        {
          isSort: true,
          sortKey: 'stationNumberForSort',
          key: 'stationName',
          name: LABEL().CHECK_LISTING_TABLE_NUMBER,
        },
        {
          isSort: true,
          sortKey: 'numberForSort',
          key: 'number',
          name: LABEL().CHECK_LISTING_CHECK_NUMBER,
        },
        // {
        //   isSort: true,
        //   sortKey: 'employeeFirstName',
        //   key: 'employeeFirstName',
        //   name: LABEL().CHECK_LISTING_OWNER
        // },
        {
          isSort: true,
          prefix: `${LABEL().CURRENCY_SYMBOL}`,
          sortKey: 'paidAmount',
          key: 'paidAmount',
          name: LABEL().CHECK_LISTING_PAID,
        },
        {
          isSort: true,
          prefix: `${LABEL().CURRENCY_SYMBOL}`,
          sortKey: 'unpaidAmount',
          key: 'unpaidAmount',
          name: LABEL().CHECK_LISTING_DUE,
        },
        // {
        //   isSort: true,
        //   sortKey: 'openDate',
        //   key: 'time',
        //   name: LABEL().CHECK_LISTING_TIME,
        // },
    ],
    headerData : [
        {
          key: ' stationNumberForSort',
        },
        {
          key: 'numberForSort',
        },
      ],
      modalHead : [
        {
          key: 'qty',
          name: LABEL().TABLE_QUANTITY,
        },
        {
          key: 'items',
          name: LABEL().TABLE_ITEM,
        },
        {
          key: 'seat',
          name: LABEL().TABLE_SEAT,
        },
        {
          key: 'sentat',
          name: LABEL().TABLE_SENTAT,
        },
        {
          key: 'amount',
          name: LABEL().TABLE_AMOUNT,
          prefix: `${LABEL().CURRENCY_SYMBOL}`,
        },
    ],
}